import { DirectorDelegationManager } from '@/components/config/DirectorDelegationManager'

export function DirectorDelegationPage() {
  return (
    <div className="max-w-6xl mx-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Stellvertretungen</h1>
          <p className="mt-1 text-sm text-gray-500">
            Verwalte Stellvertretungen — schulweit oder für einzelne Fakultäten
          </p>
        </div>
      </div>
      <DirectorDelegationManager />
    </div>
  )
}
